import React from 'react';
import { Card, CardContent } from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import Badge from '../../components/ui/Badge';
import { Plus, Bell, Mail, MessageSquare } from 'lucide-react';

export default function AdminNotificationsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between"><div><h1 className="text-2xl font-bold text-white">Notifications</h1><p className="text-sm text-slate-400">Manage notifications and announcements</p></div><Button size="sm"><Plus className="w-4 h-4 mr-1" />New Announcement</Button></div>
      <div className="grid grid-cols-3 gap-3">
        {[{ label: 'In-App', icon: Bell, count: 0 }, { label: 'Email', icon: Mail, count: 0 }, { label: 'SMS', icon: MessageSquare, count: 0 }].map((c, i) => {
          const Icon = c.icon;
          return (<Card key={i} className="p-4"><div className="flex items-center gap-3"><div className="w-10 h-10 bg-primary-500/10 rounded-lg flex items-center justify-center"><Icon className="w-5 h-5 text-primary-400" /></div><div><p className="text-sm font-medium text-white">{c.label}</p><p className="text-xs text-slate-400">{c.count} sent</p></div></div></Card>);
        })}
      </div>
      <Card><CardContent className="py-8 text-center text-slate-500 text-sm">Notification history and templates will appear here.</CardContent></Card>
    </div>
  );
}
